import { asLeftTestRequired } from './Data/S71/S71.data';

export const asLeftTestRequiredSectionData = (formName, formData) => {
    let filterViewData = { rows: [] };
    if (['S7-1'].includes(formName) && formData.F956TrfTypeSelection === 'Full') {
        filterViewData = asLeftTestRequired(formData);
    }
    return filterViewData;
};
